<template>
  <Layout
    :id="page.id"
    class="onboarding-options"
    :title="page.title"
    :subtitle="page.subtitle"
    :scrollDefaultSlot="true"
    :reverseTitleSubtitle="true"
  >
    <OptionsBody
      v-model="selectedOptions"
      :page="optionsBodyPage"
      :options="resolvedOptions"
    />
  </Layout>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import type { OnboardingSubject } from '@/models/onboarding.personalization'
import { QuestionnaireView } from '@/models/onboarding'
import type {
  DynamicOptionsPage,
  QuestionnaireFormOption,
} from '@/models/onboarding.types'

import Layout from '../Layout.vue'
import OptionsBody from './OptionsBody.vue'

const props = defineProps<{
  view: QuestionnaireView
}>()

const page = computed(() => props.view.currentPage as DynamicOptionsPage)

const optionsBodyPage = computed(() => ({
  multipleOptions: false as const,
  maxOptions: undefined,
  centerText: undefined,
  wrapInputs: undefined,
  image: undefined,
}))

const subjectKey = computed((): OnboardingSubject => {
  const selectedSubject =
    props.view.getUserChoice<string>(page.value.sourcePageId) ??
    page.value.defaultSourceSubject
  return selectedSubject as OnboardingSubject
})

const resolvedOptions = computed((): QuestionnaireFormOption[] => {
  const labels = page.value.optionsBySubject[subjectKey.value] ?? []
  return labels.map((label) => ({ label }))
})

const selectedOptions = ref<string[]>([])

watch(selectedOptions, (newValue) => {
  props.view.setCurrentChoice(newValue[0])
})
</script>

<style lang="scss" scoped>
.onboarding-options {
  :deep(.onboarding-layout__default-slot) {
    display: flex;
    flex-direction: column;
  }

  :deep(.onboarding-layout__text) {
    margin-bottom: 28px;
  }

  :deep(.onboarding-layout__subtitle) {
    color: $c-black-15;
    font-style: italic;
  }
}
</style>
